import {
  FiMenu,
  FiSearch,
  FiSun,
  FiBell,
  FiUser,
  FiSettings,
  FiCreditCard,
  FiLogOut,
  FiChevronsLeft,
  FiChevronsRight,
  FiMoon,
} from "react-icons/fi";
import { useAuth } from "../../context/AuthContext";
import { useEffect, useRef, useState } from "react";
import { useTheme } from "../../context/ThemeContext";
import { LogOut } from "lucide-react";

const Navbar = ({ onToggleSidebar, onCollapseSidebar, isCollapsed }) => {
  const { user, logout } = useAuth();
  const [openMenu, setOpenMenu] = useState(false);
  const menuRef = useRef(null);
  const { darkMode, setDarkMode } = useTheme();

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpenMenu(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="h-16 bg-white border-b px-4 md:px-6 flex items-center justify-between relative dark:bg-secondary-900 dark:border-secondary-800">
      {/* Left: menu + search */}
      <div className="flex items-center gap-3">

        {/* Mobile sidebar toggle */}
        <button
          onClick={onToggleSidebar}
          className="md:hidden p-2 rounded-lg hover:bg-gray-100"
        >
          <FiMenu className="text-xl" />
        </button>

        {/* Desktop collapse toggle */}
        <button
          onClick={onCollapseSidebar}
          className="hidden md:block p-2 rounded-lg hover:bg-gray-100"
        >
          {isCollapsed ? (
            <FiChevronsRight className="text-xl" />
          ) : (
            <FiChevronsLeft className="text-xl" />
          )}
        </button>

        {/* Search input */}
        <div className="hidden sm:flex items-center bg-gray-100 rounded-lg px-3 py-2 gap-2">
          <FiSearch className="text-gray-500" />
          <input
            type="text"
            placeholder="Search..."
            className="bg-transparent text-sm outline-none w-40 md:w-64"
          />
          <span className="hidden md:inline text-xs text-gray-400">⌘K</span>
        </div>
      </div>

      {/* Right: actions + user */}
      <div className="flex items-center gap-5">
        


        <button className="relative p-2 rounded-full hover:bg-gray-100">
          <FiBell className="text-lg" />
          <span className="absolute -top-0.5 -right-0.5 w-4 h-4 text-[10px] flex items-center justify-center rounded-full bg-red-500 text-white">
            2
          </span>
        </button>

        {/* Avatar + dropdown */}
        <div className="relative" ref={menuRef}>
          <div
            className="flex items-center gap-3 cursor-pointer"
            onClick={() => setOpenMenu((prev) => !prev)}
          >
            <div className="hidden sm:block text-right">
              <p className="text-sm font-semibold">{user?.name}</p>
              <p className="text-xs text-gray-500">{user?.email}</p>
            </div>
            <div className="w-10 h-10 rounded-full bg-blue-500 text-white flex items-center justify-center text-sm font-semibold">
              <img className="rounded-full" src="https://img.freepik.com/premium-photo/panda-with-green-background-white-egg-middle_950428-34761.jpg" alt="" />
            </div>
          </div>

          {/* Dropdown menu */}
          {openMenu && (
            <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-lg border z-50">
            <div className="px-4 py-3 border-b">
              <p className="text-sm font-semibold">
                {user?.name || 'Admin'}
              </p>
              <p className="text-xs text-gray-500">
                {user?.email || 'admin@email.com'}
              </p>
            </div>

            <button
              onClick={logout}
              className="w-full flex items-center gap-2 px-4 py-2 text-sm hover:bg-gray-100 text-red-600"
            >
              <LogOut size={16} />
              Logout
            </button>
          </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
